import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { PaginatedResponse } from './paginated-response.type';
import { SupplierLookup } from './supplier-lookup.type';

const SupplierLookupPaginatedResponse = t.intersection(
  [
    PaginatedResponse,
    t.type({
      items: nullable(t.array(SupplierLookup)),
      name: nullable(t.string),
    }),
  ],
  'SupplierLookupPaginatedResponse',
);

type SupplierLookupPaginatedResponse = t.TypeOf<
  typeof SupplierLookupPaginatedResponse
>;
export { SupplierLookupPaginatedResponse };
